import { create } from 'zustand'
import type { IResponseGetAddOns } from '../../../interfaces/src'

interface AddonsState {
  addons: IResponseGetAddOns | null
  setAddons: (addons: IResponseGetAddOns) => void
  isLoading: boolean
  setIsLoading: (isLoading: boolean) => void
  isError: boolean
  setIsError: (isError: boolean) => void
}

export const useAddonsStore = create<AddonsState>()((set) => ({
  addons: null,
  setAddons: (addons: IResponseGetAddOns) => set({ addons }),
  isLoading: false,
  setIsLoading: (isLoading: boolean) => set({ isLoading }),
  isError: false,
  setIsError: (isError: boolean) => set({ isError })
}))
